export default __webpack_public_path__ + "static/media/bayer-light.bee51710.svg";